import React from 'react';
import PropTypes from 'prop-types';
import {ThemeContext} from '../';
import {getResizeImagePaths, onImageError} from '../../../utils';

const getLogoImage = (customLogo, imageUrl) => {
  if (customLogo) {
    const {defaultImageURL, resizedImageURL} = getResizeImagePaths(customLogo, 180);

    return (
      <img src={resizedImageURL} onError={onImageError(defaultImageURL)} alt="Company Logo"/>
    );
  }

  return (
    <img src={imageUrl} alt="Company Logo"/>
  );
};

const Logo = (props) => {
  const {imageUrl, url} = props;

  return (
    <ThemeContext.Consumer>
      {(theme) => {
        const customLogo = theme.logo && theme.logo.url;

        return (
          <a className="logo" href={url}>
            {getLogoImage(customLogo, imageUrl)}
          </a>);
      }
      }
    </ThemeContext.Consumer>
  );
};

Logo.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default Logo;
